import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './auth/guards/auth.guard';

import { PoiProfileComponent } from './components/poi-profile/poi-profile.component';
import { PointsOfInterestComponent } from './components/points-of-interest/points-of-interest.component';
import { RootCategoriesComponent } from './components/rootcategories/rootcategories.component';
import { SubcategoryComponent } from './components/subcategory/subcategory.component';
import { ErrorPageComponent } from './shared/error-page/error-page.component';
import { ViewAddParentComponent } from './components/view-add-parent/view-add-parent.component';
import { ViewAddCategoryComponent } from './components/view-add-category/view-add-category.component';
import { ViewAddPoisComponent } from './components/view-add-pois/view-add-pois.component';
import { EditRootcategoryComponent } from './components/edit-rootcategory/edit-rootcategory.component';
import { EditCategoryComponent } from './components/edit-category-view/edit-category.component';
import { EditPoiViewComponent } from './components/edit-poi-view/edit-poi-view.component';
import { LoginComponent } from './auth/pages/login.component';
import { CallbackComponent } from './auth/pages/callback/callback.component';

export const PoiEdit = {
  path: 'edit',
  data: {
    breadcrumb: 'Editar punto de interés'
  },
  component: EditPoiViewComponent,
  title: 'Edit point of interest',
  canActivate: [AuthGuard]
}

export const PoiProfileRoute = {
  path: 'poi/:poiId',
  component: PoiProfileComponent,
  children:[PoiEdit],
  data: {
    breadcrumb: 'POI'
  },
  title: 'Poi Profile',
  canActivate: [AuthGuard]
}

export const PoiOfInterestRoute = {
  path: 'poi/:categoryId',
  component: PointsOfInterestComponent,
  data: {
    breadcrumb: 'POI View'
  },
  title: 'Poi View',
  canActivate: [AuthGuard]
}

export const PoisAdd = {
  path: 'add',
  data: {
    breadcrumb: 'Agregar POIS'
  },
  component: ViewAddPoisComponent,
  title: 'Add point of interest',
  canActivate: [AuthGuard]
}

export const CategoryEdit = {
  path: 'edit',
  data: {
    breadcrumb: 'Editar categoría'
  },
  component: EditCategoryComponent,
  title: 'Edit Category',
  canActivate: [AuthGuard]
}

export const CategoryAdd = {
  path: 'add',
  data: {
    breadcrumb: 'Agregar categoría'
  },
  component: ViewAddCategoryComponent,
  title: 'Add Category',
  canActivate: [AuthGuard]
}

export const CategoryPoi = {
  path: 'poi/:poiId',
  data: {
    breadcrumb: 'POI'
  },
  component: PoiProfileComponent,
  title: 'Poi',
  canActivate: [AuthGuard]
}

export const CategoryPoisAdd = {
  path: 'add-pois',
  data: {
    breadcrumb: 'Agregar POIS'
  },
  component: ViewAddPoisComponent,
  title: 'Add Pois',
  canActivate: [AuthGuard]
}

export const CategoryView = {
  path: 'category/:id',
  data: {
    breadcrumb: 'Categoría'
  },
  component: SubcategoryComponent,
  children: [
    PoiProfileRoute,
    PoiOfInterestRoute,
    CategoryAdd,
    CategoryEdit,
    CategoryPoi,
    CategoryPoisAdd,
    PoiEdit
  ],
  title: 'Category',
  canActivate: [AuthGuard]
}

export const RootCategoriesEdit = {
  path: 'edit',
  data: {
    breadcrumb: 'Editar categoría padre'
  },
  component: EditRootcategoryComponent,
  title: 'Edit parent category',
  canActivate: [AuthGuard]
}

export const RootCategoriesAdd = {
  path: 'add',
  data: {
    breadcrumb: 'Agregar categoría padre'
  },
  component: ViewAddParentComponent,
  title: 'Add parent category',
  canActivate: [AuthGuard]
}

export const RootCategoriesRoute = {
  path: 'categories',
  data: {
    breadcrumb: 'Categorías padre'
  },
  component: RootCategoriesComponent,
  children: [
    CategoryView,
    RootCategoriesAdd,
    RootCategoriesEdit
  ],
  title: 'Categories',
  canActivate: [AuthGuard]
}

export const HomeRoute = {
  path: '',
  component: RootCategoriesComponent,
  data: {
    breadcrumb: 'Inicio'
  },
  title: 'POIS',
  canActivate: [AuthGuard]
}

export const AuthRoute = {
  path: 'auth',
  loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
  title: 'Auth',
}

export const ErrorPageRoute = {
  path: '404',
  component: ErrorPageComponent,
  data: {
    breadcrumb: 'Error 404'
  },
  title: 'Error 404',
}

export const LoginRoute = {
  path: 'login',
  component: LoginComponent,
  title: "Login Page"
}

const routes: Routes = [
   {
    path: 'callback',
    component: CallbackComponent
  },
  RootCategoriesRoute,
  HomeRoute,
  AuthRoute,
  ErrorPageRoute,
  LoginRoute,
  CategoryView,
  PoiOfInterestRoute
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: false})],
  exports: [RouterModule]
})
export class AppRoutingModule { }

